import React from 'react'
import {FormProvider} from 'react-hook-form'
import FormFields from './FormFields'

const FormTemplate = ({fields, methods, i18n, ...p}) => {
    return (
        <FormProvider {...methods}>
            <FormFields fields={fields} i18n={i18n} {...p} />
        </FormProvider>
    )
}

export default FormTemplate
